import { GRID_WIDTH, GRID_HEIGHT, COLORS } from '../constants/gameConstants';

export const ownFill = (grid, ownership, x, y, targetColor, newColor, player, gridWidth = GRID_WIDTH, gridHeight = GRID_HEIGHT) => {
  const newGrid = grid.map(row => [...row]);
  const newOwnership = ownership.map(row => [...row]);
  const cellsChanged = [];
  
  // First, fill the player's current territory
  // Note: x is row index (0 to gridHeight-1), y is col index (0 to gridWidth-1)
  const queue = [[x, y]];
  const visited = new Set();
  
  while (queue.length > 0) {
    const [cx, cy] = queue.shift();
    const key = `${cx},${cy}`;
    
    if (
      cx >= 0 && cx < gridHeight &&
      cy >= 0 && cy < gridWidth &&
      !visited.has(key) &&
      newGrid[cx][cy] === targetColor &&
      newOwnership[cx][cy] === player
    ) {
      visited.add(key);
      newGrid[cx][cy] = newColor;
      cellsChanged.push([cx, cy]);
      
      // Add adjacent cells to queue
      queue.push([cx - 1, cy], [cx + 1, cy], [cx, cy - 1], [cx, cy + 1]);
    }
  }
  
  // Then, expand to adjacent cells of the new color
  let changed = true;
  while (changed) {
    changed = false;
    for (let i = 0; i < gridHeight; i++) {
      for (let j = 0; j < gridWidth; j++) {
        // If this cell is the target color and not owned by the player
        if (newGrid[i][j] === newColor && !newOwnership[i][j]) {
          // Check if it's adjacent to any cell owned by the player
          const adjacentCells = [
            [i - 1, j], [i + 1, j], [i, j - 1], [i, j + 1]
          ];
          
          for (const [nx, ny] of adjacentCells) {
            if (
              nx >= 0 && nx < gridHeight &&
              ny >= 0 && ny < gridWidth &&
              newOwnership[nx][ny] === player
            ) {
              newOwnership[i][j] = player;
              cellsChanged.push([i, j]);
              changed = true;
              break;
            }
          }
        }
      }
    }
  }
  
  return {
    newGrid,
    newOwnership,
    cellsChanged
  };
};

export const hasAbsorbableCells = (grid, ownership, playerPos, opponentColor, playerType, gridWidth = GRID_WIDTH, gridHeight = GRID_HEIGHT) => {
  const [x, y] = playerPos;
  const currentColor = grid[x][y];
  
  // For each color, check if it would expand territory
  return COLORS.some(color => {
    // Skip opponent's color
    if (color === opponentColor) {
      return false;
    }
    
    const tempGrid = grid.map(row => [...row]);
    const tempOwnership = ownership.map(row => [...row]);
    const {newOwnership} = ownFill(tempGrid, tempOwnership, x, y, currentColor, color, playerType, gridWidth, gridHeight);
    
    // Count tiles before and after
    const beforeCount = ownership.flat().filter(cell => cell === playerType).length;
    const afterCount = newOwnership.flat().filter(cell => cell === playerType).length;
    
    return afterCount > beforeCount;
  });
};